/** FuryBot — Rules Explanation Flow */
import { track } from "../utils/analytics";
import { RULE_EXPLANATIONS } from "../constants";

export function createRulesFlowHandlers(ctx) {
  const { addBot, setMessages } = ctx;

  const startRulesFlow = () => {
    track("flow_started", { flow: "rules" });
    setMessages(m => [
      ...m.map(msg => (msg.role === "bot" && msg._ruleExplain) ? { ...msg, buttons: [] } : msg),
      { role: "bot", text: "Which rule would you like to understand?", _ruleExplain: true, buttons: [
        { label: "Trailing drawdown", action: "rule_explain", data: "trailing" },
        { label: "EOD vs intraday", action: "rule_explain", data: "eod" },
        { label: "Profit splits", action: "rule_explain", data: "splits" },
        { label: "Payouts", action: "rule_explain", data: "payouts" },
        { label: "Consistency rules", action: "rule_explain", data: "consistency" },
        { label: "How evals work", action: "rule_explain", data: "evaluations" },
      ], ts: Date.now() },
    ]);
  };

  const showRuleExplanation = (topic) => {
    const rule = RULE_EXPLANATIONS[topic];
    if (!rule) return startRulesFlow();
    setMessages(m => [
      ...m.map(msg => (msg.role === "bot" && msg._ruleExplain) ? { ...msg, buttons: [] } : msg),
      { role: "bot", text: `**${rule.title}**\n\n${rule.text}`, _ruleExplain: true, buttons: [
        { label: `${rule.linkLabel}`, action: "link", data: rule.link },
        { label: "View full rules guide", action: "link", data: "/futures-prop-firm-rules" },
        { label: "Which firms use this?", action: "flow_compare" },
        { label: "Help me pick a firm", action: "flow_match" },
        { label: "Explain another rule", action: "flow_rules" },
        { label: "Main menu", action: "home" },
      ], ts: Date.now() },
    ]);
  };

  return { startRulesFlow, showRuleExplanation };
}
